export const ACT_TYPE_OPTIONS = [
  { value: 1, label: '幸运转盘' },
  { value: 2, label: '红包雨' },
  { value: 4, label: '签到活动' },
  { value: 6, label: '代理宝箱' },
  { value: 7, label: '亏损返现' },
  { value: 8, label: '累计存款奖励' },
  { value: 9, label: '首次存款奖励' },
  { value: 10000, label: '链接' },
]
